var indentation_default = {
  "indentZero": "OVb5L",
  "indentOne": "wC77x",
  "indentTwo": "_9RymO",
  "indentThree": "LQqTy",
  "indentFour": "_6QAjn",
  "indentFive": "Pjjsn",
  "indentSix": "JRp12"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
